import countries from "@/configs/countries";
let country = [];
for (let i in countries) {
    country.push({text: countries[i], val: i})
}
export default country;
